import React from 'react';
import { useTranslations } from 'next-intl';
import { H1, P } from '../Typography';
import { Error } from '../Error/Error';
import type { ContentUserT } from '../../state/user';

export function GeneralError({ user }: { user: ContentUserT }) {
  const t = useTranslations('first_impression.error');
  return (
    <Error user={user}>
      <H1 textAlign="center">{t('something_went_wrong')}</H1>
      <P textAlign="center">{t('try_refresh_or_contact_support')}</P>
    </Error>
  );
}
